'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { LogoContainer } from './LogoContainer';
import type { Size } from './types';
const E_PRIVACY_CERT_NUM = {
  b2b: '2026-E-R011',
  b2c: '2026-E-R012'
} as const;
interface CertificationBadgeProps {
  size?: Size;
  isHideCSAP?: boolean;
  isHideISMSP?: boolean;
  isHideERIVACY?: boolean;
  ePrivacyVariant?: 'b2b' | 'b2c';
  className?: string;
}
export const CertificationBadge = t0 => {
  const $ = _c(30);
  const {
    size: t1,
    isHideCSAP,
    isHideISMSP,
    isHideERIVACY,
    ePrivacyVariant: t2,
    className
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const ePrivacyVariant = t2 === undefined ? "b2c" : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex items-center gap-8", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isHideCSAP || $[3] !== size) {
    t4 = isHideCSAP ? null : <li className="flex items-start gap-8"><LogoContainer size={size}><img alt={"CSAP \uB85C\uACE0"} className={cn({
          "size-40": size === 40,
          "size-50": size === 50,
          "size-60": size === 60,
          "size-80": size === 80
        })} src="https://cdn.welfarehello.com/common/footer/csap-150px.png" title="CSAP" width={80} height={80} /></LogoContainer><p className="font-400 text-Gray-600 typo-caption2"><span className="font-600 text-Gray-700">CSAP</span><br />[인증범위] 공공기관용 웰로비즈(SaaS 표준등급)<br />[유효기간] 2025-09-30 ~ 2030-09-29</p></li>;
    $[2] = isHideCSAP;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isHideISMSP || $[6] !== size) {
    t5 = isHideISMSP ? null : <li className="flex items-start gap-8"><LogoContainer><img className={cn({
          "size-40": size === 40,
          "size-50": size === 50,
          "size-60": size === 60,
          "size-80": size === 80
        })} alt={"ISMS-P \uB85C\uACE0"} src="https://cdn.welfarehello.com/common/footer/ismsp-150px.png" width={80} height={80} /></LogoContainer><p className="text-start font-400 text-Gray-600 typo-caption2"><span className="font-600 text-Gray-700">ISMS-P</span><br />[인증범위] 웰로 서비스 및 웰로비즈 서비스<br />[유효기간] 2024-11-20 ~ 2027-11-19</p></li>;
    $[5] = isHideISMSP;
    $[6] = size;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== ePrivacyVariant || $[9] !== isHideERIVACY || $[10] !== size) {
    t6 = isHideERIVACY ? null : <li className="flex items-start gap-8"><LogoContainer><button type="button" onClick={() => {
          window.open(`https://www.eprivacy.or.kr/front/certifiedSiteMark/certifiedSiteMarkPopup.do?certCmd=E&certNum=${E_PRIVACY_CERT_NUM[ePrivacyVariant]}`, "seal", "width=527,height=720,location=no,status=no,scrollbars=no");
        }}><img alt="ePRIVACY" className={cn({
            "size-40": size === 40,
            "size-50": size === 50,
            "size-60": size === 60,
            "size-80": size === 80
          })} width={80} height={80} src="https://www.eprivacy.or.kr/images/mng/sub/mark1_eprivacy.png" title="ePRIVACY" /></button></LogoContainer><p className="font-400 text-Gray-600 typo-caption2"><span className="font-600 text-Gray-700">ePRIVACY</span><br />[인증범위] 웰로 서비스 및 웰로비즈 서비스<br />[유효기간] 2026-04-01 ~ 2027-03-31</p></li>;
    $[8] = ePrivacyVariant;
    $[9] = isHideERIVACY;
    $[10] = size;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = size === 40;
  const t8 = size === 50;
  const t9 = size === 60;
  const t10 = size === 80;
  let t11;
  if ($[12] !== t10 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t11 = cn({
      "size-40": t7,
      "size-50": t8,
      "size-60": t9,
      "size-80": t10
    });
    $[12] = t10;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <LogoContainer><img alt={"ISO27701 \uB85C\uACE0"} className={t11} src="https://cdn.welfarehello.com/common/footer/igc-150px.png" title="ISO27701" width={80} height={80} /></LogoContainer>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="font-600 text-Gray-700">ISO/IEC 27001:2022<br />ISO/IEC 27701:2019</span>;
    t14 = <br />;
    $[19] = t13;
    $[20] = t14;
  } else {
    t13 = $[19];
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p className="font-400 text-Gray-600 typo-caption2">{t13}{t14}[인증범위] 웰로 서비스 및 웰로비즈 서비스<br />[유효기간] 2024-12-24 ~ 2027-12-23</p>;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t12) {
    t16 = <li className="flex items-start gap-8">{t12}{t15}</li>;
    $[22] = t12;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t16 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t17 = <ul className={t3}>{t4}{t5}{t6}{t16}</ul>;
    $[24] = t16;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};